<template>
  <div class="box">
    <div class="boxTop">
      <div class="head">
        <div class="headBox flex align-center justify-between">
          <div class="headLeft">
            <img :src="user.morgwlogo ? user.morgwlogo : logo"  alt="" >
          </div>
          <div class="headRight">
            <a href="https://ysb.emof.cn">
              <div class="headRightTel">
                返回首页
              </div>
            </a>
          </div>
        </div>
      </div>
      <div class="boxCenter">
        <div class="disFlex">
          <div class="boxCenterLeft">

          </div>
          <div class="boxCenterRight">
            <div class="rightLogin">
              <div class="loginTab">
                <div class="zhTab act">绑定手机号</div>
              </div>
              <div class="loginInput">
                <el-form :model="ruleForm" :rules="rules" ref="ruleForm" class="demo-ruleForm">
                  <div class="phoneLogin">
                    <div class="inputBox">
                      <el-form-item prop="tel">
                        <el-input
                          v-model.number="ruleForm.tel"
                          placeholder="请输入手机号"
                        >
                          <i slot="prefix" class="iconfont iconicon-user iconColor"></i>
                        </el-input>
                      </el-form-item>
                    </div>
                    <div class="inputBox">
                      <el-form-item prop="code">
                        <el-input
                          v-model.number="ruleForm.code"
                          placeholder="请输入验证码"
                        >
                          <i slot="prefix" class="iconfont iconshouji iconColor"></i>
                        </el-input>
                      </el-form-item>
                      <div v-show="show" class="getCode" @click="getCode">获取验证码</div>
                      <div v-show="!show" class="getCodeE">{{count}}s</div>
                    </div>
<!--                    <div class="inputBox">-->
<!--                      <el-form-item prop="pass">-->
<!--                        <el-input-->
<!--                          v-model="ruleForm.pass"-->
<!--                          type="password"-->
<!--                          placeholder="请输入密码"-->
<!--                        >-->
<!--                          <i slot="prefix" class="iconfont iconmima iconColor"></i>-->
<!--                        </el-input>-->
<!--                      </el-form-item>-->
<!--                    </div>-->
<!--                    <div class="inputBox">-->
<!--                      <el-form-item prop="password">-->
<!--                        <el-input-->
<!--                          v-model="ruleForm.password"-->
<!--                          type="password"-->
<!--                          placeholder="请再次输入密码"-->
<!--                        >-->
<!--                          <i slot="prefix" class="iconfont iconmima iconColor"></i>-->
<!--                        </el-input>-->
<!--                      </el-form-item>-->
<!--                    </div>-->
<!--                    <div class="inputBox" style="margin-top: -14px;">-->
<!--                      <el-form-item>-->
<!--                        <el-checkbox v-model="ruleForm.checked">我已阅读并同意 <span class="act">《易书宝使用协议》</span> </el-checkbox>-->
<!--                      </el-form-item>-->
<!--                    </div>-->
                  </div>
                  <el-form-item>
                    <el-button class="loginBtn" @click="login('ruleForm')">绑定</el-button>
                  </el-form-item>
                </el-form>
              </div>
<!--              <div class="wxLogin">-->
<!--                <div class="wxLoginTit">使用其他方式登录</div>-->
<!--                <div class="wxLoginBtn">-->
<!--                  <img src="../../assets/images/wxIcon.png" alt="">-->
<!--                </div>-->
<!--              </div>-->
<!--              <div class="notZh">-->
<!--                我已有账号，<span @click="to('/login')">我要登录</span>-->
<!--              </div>-->
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="boxFoot">
      <div style="width: 1200px;margin: 0 auto;" class="flex align-center justify-between">
        <div class="boxFootLeft">
          <div class="img">
            <img src="../../assets/images/tel.png" alt="">
          </div>
          <div class="tex">
            <div class="texTop">服务电话：400-999-6541</div>
            <div class="texBottom">周一至周日8:00 - 12:00</div>
          </div>
        </div>

        <div class="boxFootRight flex align-center justify-between">
          <div>
            <div class="img">
              <img src="../../assets/images/erweima_zf.png" alt="">
            </div>
            <div class="tex">免费获取更多社会组织服务</div>
          </div>
          <div>
            <div class="img">
              <img src="../../assets/images/erweima_emof.jpg" alt="">
            </div>
            <div class="tex">了解更多信息化产品</div>
          </div>
        </div>
      </div>
    </div>
    <div class="end">
      Copyright 益魔方
      <a href="https://beian.miit.gov.cn/" target="_blank" style="color: rgb(255, 255, 255);">京ICP备15038897号-3</a>
      <a href="http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=11010802038214" target="_blank" class="margin-lr-xs" style="color: rgb(255, 255, 255);">
        <img src="http://www.beian.gov.cn/img/new/gongan.png" alt="" style="vertical-align: text-top;">京公网安备11010802038214号</a>
      北京易魔方科技集团有限公司  版权所有
    </div>
  </div>
</template>

<script>
  export default {
    name: "login",
    data() {
      // 密码验证
      var validatePass = (rule, value, callback) => {
        if (value === '') {
          callback(new Error('请输入密码'));
        } else {
          if (this.ruleForm.password !== '') {
            this.$refs.ruleForm.validateField('password');
          }
          callback();
        }
      };
      var validatePass2 = (rule, value, callback) => {
        if (value === '') {
          callback(new Error('请再次输入密码'));
        } else if (value !== this.ruleForm.pass) {
          callback(new Error('两次输入密码不一致!'));
        } else {
          callback();
        }
      };
      return {
        logo:require('@/assets/images/logo.png'),
        show: true, // 60秒倒计时
        count: '',
        timer: null,
        unid: '',
        qianM: '',
        ruleForm: {
          checked: false,
          tel: '',
          code: '',
          pass: '',
          password: ''
        },
        rules: {
          pass: [
            { validator: validatePass, trigger: 'blur' }
          ],
          password: [
            { validator: validatePass2, trigger: 'blur' }
          ],
          tel: [
            {required: true, message: '请输入手机号'},
            {validator: this.validateTel}
          ],
          code: [
            {required: true, message: '请输入验证码'},
            {type:'number', min: 6, message: '验证码为6位数字', }
          ],
        }
      }
    },
    computed: {
      user() {
        return this.$store.state.user
      }
    },
    created() {
      this.unid = this.$router.history.current.query.unid
    },
    methods: {

      // 手机号验证
      validateTel(rule, value, callback) {
        let reg = /^1[3456789]\d{9}$/;
        if (value === '') {
          callback(new Error('请输入手机号'));
        } else if (!reg.test(value)) {
          callback(new Error('请输入正确的手机号'));
        } else {
          callback();
        }
      },
      // 表单提交
      login(formName) {
        this.$refs[formName].validate((valid) => {
          console.log(valid)
          if (valid) {
            const loading = this.$loading({
              lock: true,
              text: 'Loading',
              spinner: 'el-icon-loading',
              background: 'rgba(0, 0, 0, 0.7)'
            });
            this.$api.apiContent.bindPhone({
              phone: this.ruleForm.tel,
              code:this.ruleForm.code,
              data: this.unid
            }).then(res => {
              loading.close();
              this.$messageSuccess(res.msg);
              this.$store.state.user = res.data
              this.$store.state.emofUserTokenSafer = res.data.emofUserTokenSafer
              this.$router.push({
                path: '/notLogin'
              })
              }).catch(res => {
              loading.close();
              this.$messageError(res.msg);
            })
          } else {
            console.log('error submit!!');
            return false;
          }
        });
      },
      // 获取验证码
      getCode() {
        let reg = /^1[3456789]\d{9}$/;
        if (this.ruleForm.tel === '') {
          this.$messageError('请输入手机号');
          return
        } else if (!reg.test(this.ruleForm.tel)) {
          this.$messageError('请输入正确的手机号');
          return
        } else {
          this.$messageSuccess('发送成功请稍等！');
          this.getCodeTime()
          this.$api.apiContent.sendNum({
            phone: this.ruleForm.tel
          }).then(res => {
            this.qianM = res.data
          }).catch(res => {
            this.$messageError(res.msg);
          })
        }
      },
      // 验证码倒计时
      getCodeTime() {
        const TIME_COUNT = 60;
        if (!this.timer) {
          this.count = TIME_COUNT;
          this.show = false;
          this.timer = setInterval(() => {
            if (this.count > 0 && this.count <= TIME_COUNT) {
              this.count--;
            } else {
              this.show = true;
              clearInterval(this.timer);
              this.timer = null;
            }
          }, 1000)
        }
      },
      // 表单清空
      loginReset() {
        this.$refs.ruleForm.resetFields()
      },
      // 跳转
      to(path){
        this.$router.push(path)
      },
    }
  }
</script>

<style scoped lang="scss">
.iconColor {
  color: #999;
  font-size: 22px;
}

.act {
  color: #fff !important;
  border-bottom: 2px solid #fff;
}

.box {
  width: 100%;
  height: 100%;
  /*overflow-y: scroll;*/

  .boxTop {
    width: 100%;
    height: 822px;
    background: url(../../assets/images/login-bg.jpg) no-repeat bottom center;


    .head {
      width: 100%;
      height: 80px;
      display: flex;
      justify-content: space-between;
      align-items: center;
      background-color: #0a2240;

      .headBox {
        width: 1200px;
        margin: 0 auto;
        height: 80px;
        display: flex;
        justify-content: space-between;

        .headLeft {


          img {
            //width: 520px;
            height: 50px;
            margin-top: 10px;
          }
        }

        .headRight {
          display: flex;
          justify-content: space-between;

          .headRightTel {
            font-size: 16px;
            color: #ffffff;
            width: 156px;
            height: 40px;
            line-height: 40px;
            background-color: #ff9600;
            border-radius: 20px;
            text-align: center;
            cursor: pointer;
          }
        }
      }
    }

    .boxCenter {
      min-width: 1200px;
      margin-top: 100px;
      display: flex;
      justify-content: center;

      .disFlex {
        width: 1200px;
        display: flex;
        justify-content: space-between;

        .boxCenterLeft {
          width: 365px;
          height: 270px;
          display: flex;
          justify-content: space-between;
          flex-wrap: wrap;

          .leftNav {
            width: 150px;
            margin-top: 90px;
            /*cursor: pointer;*/

            img {
              width: 43px;
              height: 48px;
              margin-left: 54px;
            }

            .tex {
              width: 100%;
              font-size: 24px;
              color: #ffffff;
              text-align: center;
              margin-top: 15px;
            }
          }
        }

        .boxCenterRight {
          width: 410px;
          height: 520px;
          border-radius: 10px;
          display: flex;
          justify-content: center;
          background-color: #0a2240;
          position: relative;
          padding: 45px;
          z-index: 1;
          &:before{
            position: absolute;
            width: 489px;
            height: 450px;
            margin: 0 auto;
            background: rgba(10,34,64,.3);
            border-radius: 10px;
            top: 50%;
            left: 50%;
            transform: translate(-50%,-50%);
            content: "";
            z-index: -1;
          }
          &:after{
            position: absolute;
            width: 561px;
            height: 357px;
            background: rgba(10,34,64,.1);
            border-radius: 10px;
            top: 50%;
            left: 50%;
            transform: translate(-50%,-50%);
            content: "";
            z-index: -1;
          }










          .rightLogin {
            width: 348px;

            .loginTab {
              width: 100%;
              display: flex;
              align-items: center;
              justify-content: center;
              border-bottom: 1px solid rgba(255,255,255,.5);
              .zhTab {
                font-size: 18px;
                line-height: 40px;
                color: rgba(255,255,255,.5);
                cursor: pointer;
              }

              span {
                font-size: 16px;
                color: #bcbbbb;
                padding: 0 40px;
              }

              .kjTab {
                font-size: 18px;
                line-height: 40px;
                color: rgba(255,255,255,.5);
                cursor: pointer;
              }
            }

            .loginInput {
              width: 100%;
              margin-top: 25px;

              .accountLogin {
                width: 100%;

                .inputBox {
                  width: 100%;
                  position: relative;

                  .notPass {
                    position: absolute;
                    right: 12px;
                    font-size: 12px;
                    top: 15px;
                    color: #fff;
                    cursor: pointer;
                  }

                  input {
                    width: 348px;
                    height: 52px;
                    border-radius: 8px;
                    border: solid 1px #e2e2e1;
                  }
                }
              }

              .phoneLogin {
                width: 100%;

                .inputBox {
                  width: 100%;
                  position: relative;

                  .getCode {
                    position: absolute;
                    right: 12px;
                    font-size: 12px;
                    top: 15px;
                    color: #fff;
                    cursor: pointer;
                  }

                  .getCodeE {
                    position: absolute;
                    right: 12px;
                    font-size: 12px;
                    top: 12px;
                    color: #999;
                    cursor: pointer;
                  }


                  input {
                    width: 348px;
                    height: 52px;
                    border-radius: 8px;
                    border: solid 1px #e2e2e1;
                  }
                }
              }

              .loginBtn {
                width: 100%;
                height: 46px!important;
                background-image: linear-gradient(
                    168deg,#ffb400,#fc7802),linear-gradient(#ff9600,#ff9600);
                background-blend-mode: normal,normal;
                border-radius: 10px;
                text-align: center;
                font-size: 18px;
                line-height: 46px;
                color: #fff;
                border: 0;
                cursor: pointer;
                -webkit-user-select: none;
                -moz-user-select: none;
                -ms-user-select: none;
                user-select: none;
              }
            }

            .wxLogin {
              margin-top: 20px;

              .wxLoginTit {
                line-height: 30px;
                text-align: center;
                color: #bcbbbb;
                position: relative;

                &:before {
                  position: absolute;
                  top: 15px;
                  left: 0;
                  content: '';
                  width: 85px;
                  height: 1px;
                  background: #bcbbbb;
                }

                &:after {
                  position: absolute;
                  top: 15px;
                  right: 0;
                  content: '';
                  width: 85px;
                  height: 1px;
                  background: #bcbbbb;
                }
              }

              .wxLoginBtn {
                width: 100%;
                text-align: center;
                margin-top: 20px;

                img {
                  width: 46px;
                  height: 46px;
                  cursor: pointer;
                }
              }
            }

            .notZh {
              width: 100%;
              text-align: right;
              font-size: 12px;
              color: #fff;
              margin-top: 20px;

              span {
                color: #ffb400;
                cursor: pointer;
              }
            }
          }
        }
      }
    }
  }

  .boxFoot {
    width: 100%;
    background-color: #0a2240;

    .boxFootLeft {



      .img {
        width: 24px;
        float: left;
        margin-top: 4px;

        img {
          width: 24px;

        }
      }

      .tex {
        display: inline-block;
        margin-left: 15px;

        .texTop {
          font-size: 18px;
          color: #fff;
        }

        .texCenter {
          font-size: 20px;
          font-weight: bold;
          color: #fff;
        }

        .texBottom {
          font-size: 14px;
          color: #bcbbbb;
        }
      }
    }

    .boxFootRight {

      height: 120px;
      margin-top: 30px;

      .img {
        width: 175px;
        height: 80px;

        img {
          display: block;
          width: 80px;
          height: 80px;
          margin: 0 auto;
        }
      }

      .tex {
        font-size: 14px;
        width: 175px;
        text-align: center;
        color: #fff;
        margin-top: 10px;
      }
    }
  }

  .end {
    width: 100%;
    height: 50px;
    background-color: #0a2240;
    line-height: 50px;
    font-size: 14px;
    color: #fff;
    text-align: center;
    a{
      color: #fff;
    }
  }
}
</style>
